import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.2904 8.24992C13.2904 8.85771 13.0489 9.4406 12.6192 9.87037C12.1894 10.3001 11.6065 10.5416 10.9987 10.5416C10.3909 10.5416 9.80802 10.3001 9.37824 9.87037C8.94847 9.4406 8.70703 8.85771 8.70703 8.24992C8.70703 7.64213 8.94847 7.05924 9.37824 6.62947C9.80802 6.19969 10.3909 5.95825 10.9987 5.95825C11.6065 5.95825 12.1894 6.19969 12.6192 6.62947C13.0489 7.05924 13.2904 7.64213 13.2904 8.24992Z",
		stroke: "#086ED6",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.1514 16.0361C11.8418 16.334 11.4288 16.5004 10.9991 16.5004C10.5695 16.5004 10.1565 16.334 9.84689 16.0361C7.0153 13.2925 3.22122 10.2281 5.07105 5.77859C6.07297 3.37234 8.47464 1.83325 10.9991 1.83325C13.5236 1.83325 15.9262 3.37325 16.9272 5.77859C18.7752 10.2217 14.9903 13.3017 12.1514 16.0361Z",
		stroke: "#086ED6",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPin;
